import { useContext } from "react"
import { AppContext } from "../App"
import { MdChevronLeft } from "react-icons/md";
import { IoNotificationsOutline } from "react-icons/io5";
import { getTopBarTitle, parseJson } from "../Helpers";

export default function TopBar(props) {

  const appContext = useContext(AppContext);
  const title = getTopBarTitle(appContext);
  const newNotifications = parseJson(
    appContext.currentUserData?.newNotifications,
    []
  );

  return (
    <div
      className="TopBar mShadow3"
    >

      <div
        className="container d-flex"
        style={{
          height: "100%",
        }}
      >

        <div
          className="mTitle text-start mOneLineText flex-grow-1 d-flex"
        >
          {
            (
              (appContext.navItem !== 'scan' && appContext.navItem) ||
              (appContext.navItem === 'scan' && appContext.navSubItem)
            ) ?
            <MdChevronLeft
              className="align-self-center mNoMargin"
              size={38}
              onClick={appContext.navBack}
            />
            :""
          }
          <span
            className="align-self-center mNoMargin font-bold"
            style={{
              fontSize: "24px"
            }}
          >
            {title}
          </span>
        </div>

        <div
          className="mIcon text-end"
          onClick={() => {
            appContext.navTo({
              item: 'notifications',
            })
          }}
        >
          <IoNotificationsOutline
            className="mSymbol"
          />
          {
            (newNotifications.length > 0) ?
            <span className="mBadge">{newNotifications.length}</span>
            :""
          }
        </div>

      </div>
    </div>
  )
}
